import React, { useEffect, useState } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';

import Call from './components/Call';
import Residents from './components/Residents';
import OutOfRange from './components/OutOfRange';

// TODO: read from an environment/build variable
const mainBuildingId = 'c9b1eea7-db0c-46bc-ab68-60a3b1f5057a';

const tokens = window.location.pathname.split('/');
const buildingId = tokens[0] === 'buildings' ? tokens[1] : tokens[1] === 'buildings' ? tokens[2] : mainBuildingId;

const App = () => {
  const [baseURL, setBaseURL] = useState(null);

  useEffect(() => {
    setBaseURL(`${window.location.protocol}//${window.location.host}`);
  }, [setBaseURL]);

  return (
    <>
      <CssBaseline />
      <HashRouter>
        <Switch>
          <Route path="/" exact={true}>
            <Redirect to={`/buildings/${buildingId}/doorbell/residents`} />
          </Route>
          <Route
            path="/buildings/:id/doorbell/"
            exact={true}
            render={(props) => <Redirect to={`/buildings/${props.match.params.id}/doorbell/residents`} />}
          />
          <Route
            path="/buildings/:id/doorbell/residents"
            exact={true}
            render={(props) => {
              return <Residents baseURL={baseURL} buildingId={props.match.params.id} history={props.history} />;
            }}
          />
          <Route
            path="/buildings/:id/doorbell/out-of-range"
            exact={true}
            render={(props) => {
              return <OutOfRange />;
            }}
          />
          <Route
            path="/buildings/:buildingId/doorbell/residents/:residentId/call"
            exact={true}
            render={(props) => {
              return (
                <Call
                  {...props}
                  baseURL={baseURL}
                  buildingId={props.match.params.buildingId}
                  residentId={props.match.params.residentId}
                  residentName={props.match.params.residentName}
                />
              );
            }}
          />
        </Switch>
      </HashRouter>
    </>
  );
};

export default App;
